module.exports = __webpack_public_path__ + "img/1437348106.e33d580f.jpg";